import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ReviewsSection.css";
import faqPlusIcon from "../assets/icons/faq_plus.svg";
import sectionLabel from "../assets/icons/section_label.svg";
import btnArrow from "../assets/icons/btn_arrow.svg";

const faqs = [
  {
    q: "Do I need a consultation?",
    a: "No in-person consultation is required. Our detailed intake form collects all the information your licensed practitioner needs to select the right formula for you.",
  },
  {
    q: "How are formulas customized?",
    a: "Your intake is reviewed by a licensed herbal practitioner trained in Traditional Chinese Medicine who selects and adjusts herbs based on your symptoms, constitution, and health history.",
  },
  {
    q: "Can my formula change over time?",
    a: "Yes. As your symptoms shift and your health improves, your formula can be updated. Ongoing monthly support allows your practitioner to refine your formula as you progress.",
  },
  {
    q: "What herbs do you use?",
    a: "We use high-quality, traditionally sourced Chinese medicinal herbs. All formulas are reviewed for safety, purity, and interaction with common medications.",
  },
  {
    q: "How long does shipping take?",
    a: "We ship nationwide. Most orders are prepared and shipped within 3–5 business days after your intake is reviewed and your formula is selected.",
  },
  {
    q: "Do you work with chronic conditions?",
    a: "Yes. Chinese herbal medicine is particularly effective for chronic, recurring, and complex conditions. Our practitioners are experienced in addressing root patterns, not just symptoms.",
  },
];

const ReviewsSection = () => {
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <div className="reviews-left flex-center">
          <div className="reviews-left-top">
            <div className="reviews-section-label flex-center">
              <img src={sectionLabel} alt="" width="192" height="32" />
            </div>
            <h2 className="reviews-title">Frequently Asked Questions</h2>
          </div>
          <div className="reviews-contact-block">
            <p className="reviews-contact-text">Still have questions?</p>
            <Link to="/contact" className="reviews-contact-btn">
              Contact Us
              <img src={btnArrow} alt="" width="20" height="20" />
            </Link>
          </div>
        </div>
        <div className="reviews-right">
          {faqs.map((faq, i) => (
            <div
              className={`reviews-faq-item${open === i ? " reviews-faq-item--open" : ""}`}
              key={i}
            >
              <button
                className="reviews-faq-question"
                onClick={() => toggle(i)}
                aria-expanded={open === i}
              >
                <span>{faq.q}</span>
                <div className="reviews-faq-icon">
                  <img
                    src={faqPlusIcon}
                    alt=""
                    style={{
                      transform: open === i ? "rotate(45deg)" : "none",
                      transition: "transform 0.2s",
                    }}
                  />
                </div>
              </button>
              {open === i && (
                <div className="reviews-faq-answer">
                  <p>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
